// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import action from './action.svg';

interface ActionIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: ActionNames;
}

export function ActionIcon({ name, ...props }: ActionIconProps) {
  return <Icon {...props} link={action} name={name} />;
}

type ActionNames =
  | '124'
  | '3d_rotation'
  | 'abc'
  | 'accessibility_new'
  | 'accessibility'
  | 'accessible_forward'
  | 'accessible'
  | 'account_balance_wallet'
  | 'account_box'
  | 'add_card'
  | 'add_shopping_cart'
  | 'add_task'
  | 'add_to_drive'
  | 'addchart'
  | 'admin_panel_settings'
  | 'ads_click'
  | 'alarm_add'
  | 'alarm_off'
  | 'alarm_on'
  | 'alarm'
  | 'all_inbox'
  | 'all_out'
  | 'analytics'
  | 'anchor'
  | 'android'
  | 'announcement'
  | 'api'
  | 'app_blocking'
  | 'app_shortcut'
  | 'arrow_circle_down'
  | 'arrow_circle_left'
  | 'arrow_circle_right'
  | 'arrow_circle_up'
  | 'arrow_right_alt'
  | 'article'
  | 'aspect_ratio'
  | 'assessment'
  | 'assignment_ind'
  | 'assignment_late'
  | 'assignment_return'
  | 'assignment_returned'
  | 'assignment_turned_in'
  | 'assignment'
  | 'assured_workload'
  | 'autorenew'
  | 'backup_table'
  | 'backup'
  | 'balance'
  | 'batch_prediction'
  | 'book_online'
  | 'book'
  | 'bookmark_add'
  | 'bookmark_added'
  | 'bookmark_border'
  | 'bookmark_remove'
  | 'bookmark'
  | 'bookmarks'
  | 'browse_gallery'
  | 'bug_report'
  | 'build_circle'
  | 'build'
  | 'cached'
  | 'calendar_month'
  | 'calendar_view_day'
  | 'calendar_view_month'
  | 'calendar_view_week'
  | 'camera_enhance'
  | 'cancel_schedule_send'
  | 'card_giftcard'
  | 'card_membership'
  | 'card_travel'
  | 'change_history'
  | 'chrome_reader_mode'
  | 'circle_notifications'
  | 'class'
  | 'close_fullscreen'
  | 'code_off'
  | 'code'
  | 'comment_bank'
  | 'commit'
  | 'commute'
  | 'compare_arrows'
  | 'compress'
  | 'contact_page'
  | 'contact_support'
  | 'contactless'
  | 'copyright'
  | 'credit_card_off'
  | 'credit_card'
  | 'css'
  | 'currency_exchange'
  | 'dangerous'
  | 'dashboard_customize'
  | 'dashboard'
  | 'data_exploration'
  | 'data_thresholding'
  | 'date_range'
  | 'delete_forever'
  | 'delete_outline'
  | 'density_large'
  | 'density_medium'
  | 'density_small'
  | 'disabled_by_default'
  | 'disabled_visible'
  | 'display_settings'
  | 'dns'
  | 'done_all'
  | 'done_outline'
  | 'done'
  | 'donut_large'
  | 'donut_small'
  | 'drag_indicator'
  | 'dynamic_form'
  | 'edit_calendar'
  | 'edit_off'
  | 'eject'
  | 'euro_symbol'
  | 'event_repeat'
  | 'event_seat'
  | 'event'
  | 'exit_to_app'
  | 'expand'
  | 'explore_off'
  | 'explore'
  | 'extension_off'
  | 'extension'
  | 'face'
  | 'fact_check'
  | 'fax'
  | 'feedback'
  | 'file_present'
  | 'filter_alt_off'
  | 'filter_alt'
  | 'find_in_page'
  | 'find_replace'
  | 'fingerprint'
  | 'fit_screen'
  | 'flaky'
  | 'flight_land'
  | 'flight_takeoff'
  | 'flip_to_back'
  | 'flip_to_front'
  | 'flutter_dash'
  | 'free_cancellation'
  | 'g_translate'
  | 'gavel'
  | 'generating_tokens'
  | 'get_app'
  | 'gif_box'
  | 'gif'
  | 'grade'
  | 'grading'
  | 'group_work'
  | 'help_center'
  | 'help_outline'
  | 'help'
  | 'hide_source'
  | 'highlight_alt'
  | 'highlight_off'
  | 'history_toggle_off'
  | 'history'
  | 'hls_off'
  | 'hls'
  | 'horizontal_split'
  | 'hotel_class'
  | 'hourglass_disabled'
  | 'hourglass_empty'
  | 'hourglass_full'
  | 'html'
  | 'http'
  | 'https'
  | 'important_devices'
  | 'info'
  | 'input'
  | 'install_desktop'
  | 'install_mobile'
  | 'integration_instructions'
  | 'invert_colors'
  | 'javascript'
  | 'join_full'
  | 'join_inner'
  | 'join_left'
  | 'join_right'
  | 'label_important'
  | 'label_off'
  | 'label'
  | 'language'
  | 'leaderboard'
  | 'lightbulb_circle'
  | 'lightbulb'
  | 'line_style'
  | 'line_weight'
  | 'list'
  | 'lock_clock'
  | 'lock_open'
  | 'lock_person'
  | 'lock_reset'
  | 'lock'
  | 'login'
  | 'logout'
  | 'loyalty'
  | 'manage_accounts'
  | 'manage_history'
  | 'mark_as_unread'
  | 'markunread_mailbox'
  | 'maximize'
  | 'mediation'
  | 'minimize'
  | 'model_training'
  | 'network_ping'
  | 'new_label'
  | 'next_plan'
  | 'nightlight_round'
  | 'no_accounts'
  | 'noise_aware'
  | 'noise_control_off'
  | 'not_accessible'
  | 'not_started'
  | 'note_add'
  | 'offline_bolt'
  | 'offline_pin'
  | 'on_device_training'
  | 'online_prediction'
  | 'opacity'
  | 'open_in_browser'
  | 'open_in_full'
  | 'open_in_new_off'
  | 'open_in_new'
  | 'open_with'
  | 'outbound'
  | 'outbox'
  | 'outlet'
  | 'output'
  | 'pageview'
  | 'paid'
  | 'pan_tool_alt'
  | 'pan_tool'
  | 'payment'
  | 'pending_actions'
  | 'pending'
  | 'percent'
  | 'perm_camera_mic'
  | 'perm_contact_calendar'
  | 'perm_data_setting'
  | 'perm_device_information'
  | 'perm_identity'
  | 'perm_media'
  | 'perm_phone_msg'
  | 'perm_scan_wifi'
  | 'pets'
  | 'php'
  | 'picture_in_picture_alt'
  | 'picture_in_picture'
  | 'pin_end'
  | 'pin_invoke'
  | 'pinch'
  | 'plagiarism'
  | 'play_for_work'
  | 'polymer'
  | 'power_settings_new'
  | 'pregnant_woman'
  | 'preview'
  | 'print'
  | 'privacy_tip'
  | 'private_connectivity'
  | 'production_quantity_limits'
  | 'published_with_changes'
  | 'query_builder'
  | 'question_answer'
  | 'question_mark'
  | 'quickreply'
  | 'receipt'
  | 'record_voice_over'
  | 'redeem'
  | 'remove_done'
  | 'remove_shopping_cart'
  | 'reorder'
  | 'report_problem'
  | 'request_page'
  | 'restore_from_trash'
  | 'restore_page'
  | 'restore'
  | 'rocket_launch'
  | 'rocket'
  | 'room'
  | 'rounded_corner'
  | 'rowing'
  | 'rule'
  | 'satellite_alt'
  | 'saved_search'
  | 'savings_outline'
  | 'savings'
  | 'schedule_send'
  | 'schedule'
  | 'search_off'
  | 'segment'
  | 'send_and_archive'
  | 'sensors_off'
  | 'sensors'
  | 'settings_accessibility'
  | 'settings_applications'
  | 'settings_backup_restore'
  | 'settings_bluetooth'
  | 'settings_brightness'
  | 'settings_cell'
  | 'settings_ethernet'
  | 'settings_input_antenna'
  | 'settings_input_component'
  | 'settings_input_composite'
  | 'settings_input_hdmi'
  | 'settings_input_svideo'
  | 'settings_overscan'
  | 'settings_phone'
  | 'settings_power'
  | 'settings_remote'
  | 'settings_voice'
  | 'shop_2'
  | 'shop_two'
  | 'shop'
  | 'shopping_bag'
  | 'shopping_basket'
  | 'shopping_cart_checkout'
  | 'shopping_cart'
  | 'smart_button'
  | 'source'
  | 'space_dashboard'
  | 'spatial_audio_off'
  | 'spatial_audio'
  | 'spatial_tracking'
  | 'speaker_notes_off'
  | 'speaker_notes'
  | 'spellcheck'
  | 'star_rate'
  | 'stars'
  | 'sticky_note_2'
  | 'store'
  | 'subject'
  | 'subtitles_off'
  | 'supervised_user_circle'
  | 'supervisor_account'
  | 'support'
  | 'swap_horiz'
  | 'swap_horizontal_circle'
  | 'swap_vert'
  | 'swap_vertical_circle'
  | 'swipe_down_alt'
  | 'swipe_down'
  | 'swipe_left_alt'
  | 'swipe_right_alt'
  | 'swipe_up_alt'
  | 'swipe_up'
  | 'swipe_vertical'
  | 'swipe'
  | 'switch_access_shortcut_add'
  | 'switch_access_shortcut'
  | 'sync_alt'
  | 'system_update_alt'
  | 'tab_unselected'
  | 'tab'
  | 'table_view'
  | 'task_alt'
  | 'terminal'
  | 'text_rotate_up'
  | 'text_rotate_vertical'
  | 'text_rotation_angledown'
  | 'text_rotation_angleup'
  | 'text_rotation_down'
  | 'text_rotation_none'
  | 'theaters'
  | 'thumb_down_off_alt'
  | 'thumb_down'
  | 'thumb_up_off_alt'
  | 'thumb_up'
  | 'thumbs_up_down'
  | 'timeline'
  | 'tips_and_updates'
  | 'toc'
  | 'today'
  | 'token'
  | 'touch_app'
  | 'tour'
  | 'track_changes'
  | 'translate'
  | 'trending_down'
  | 'trending_flat'
  | 'trending_up'
  | 'try'
  | 'turned_in_not'
  | 'turned_in'
  | 'unpublished'
  | 'update_disabled'
  | 'update'
  | 'upgrade'
  | 'verified_outline'
  | 'verified_user'
  | 'verified'
  | 'vertical_split'
  | 'view_agenda'
  | 'view_array'
  | 'view_carousel'
  | 'view_column'
  | 'view_comfy_alt'
  | 'view_compact_alt'
  | 'view_cozy'
  | 'view_day'
  | 'view_headline'
  | 'view_in_ar'
  | 'view_kanban'
  | 'view_list'
  | 'view_module'
  | 'view_quilt'
  | 'view_sidebar'
  | 'view_stream'
  | 'view_timeline'
  | 'view_week'
  | 'visibility_off'
  | 'visibility'
  | 'voice_over_off'
  | 'webhook'
  | 'width_full'
  | 'width_normal'
  | 'width_wide'
  | 'wifi_protected_setup'
  | 'work_history'
  | 'work_off'
  | 'work_outline'
  | 'wysiwyg'
  | 'youtube_searched_for'
  | 'zoom_in'
  | 'zoom_out'
  ;

